import { Plus } from "lucide-react";

import { Button } from "@/components";
import { useI18n } from "@/context/i18n";

export const InvoicesPage: React.FC = () => {
  const { t } = useI18n();

  return (
    <div className="flex flex-col w-full h-full space-y-6 p-4">
      <div className="flex flex-row items-center justify-between">
        <div className="flex flex-col w-full px-2">
          <h1 className="text-3xl font-bold tracking-tight">
            {t("invoices.title")}
          </h1>
          <p className="text-muted-foreground">{t("invoices.description")}</p>
        </div>
        <div className="flex justify-end mb-4">
          <Button onClick={() => {}}>
            <Plus className="mr-2 h-4 w-4" />
            {t("generic.new")}
          </Button>
        </div>
      </div>
    </div>
  );
};
